import { useContext, useEffect } from "react";
import { UsinasContext } from "../context/UsinasContextProvider";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { Typography } from "@mui/material";
import { Location } from "../types";
import NumberInput from "../../../main/components/NumberInput";

export const schema = yup.object().shape({
  latitude: yup
    .number()
    .typeError("Latitude deve ser um número")
    .min(-90, "Latitude deve ser maior que -90")
    .max(90, "Latitude deve ser menor que 90")
    .required("Latitude é obrigatória"),
  longitude: yup
    .number()
    .typeError("Longitude deve ser um número")
    .min(-180, "Longitude deve ser maior que -180")
    .max(180, "Longitude deve ser menor que 180")
    .required("Longitude é obrigatória"),
});
export type UpdateIndicatorsData = yup.InferType<typeof schema>;

export const inputStyle = {
  marginBottom: "10px",
  paddingRight: "10px",
  paddingLeft: "10px",
  width: "250px",
};
export const UsinaLocationEditForm = React.forwardRef(
  (
    props: {
      setNewLocation: (location: Location) => void;
      setOpenConfirmLocationEditModal: (open: boolean) => void;
      open: boolean;
      setCanEdit: (canEdit: boolean) => void;
    },
    ref
  ) => {
    const {
      control,
      formState: { errors },
      setValue,
      handleSubmit,
      watch,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const { usina } = useContext(UsinasContext);
    const location = usina?.location;
    const { setNewLocation, setOpenConfirmLocationEditModal, open } = props;
    const data = watch();

    const locationIsDifferent =
      (location?.latitude && data.latitude !== location.latitude) ||
      (!location?.latitude && data.latitude !== 0) ||
      (location?.longitude && data.longitude !== location.longitude) ||
      (!location?.longitude && data.longitude !== 0)
        ? true
        : false;

    useEffect(() => {
      if (!data.latitude && !data.longitude) {
        props.setCanEdit(false);
        return;
      }
      if (locationIsDifferent) {
        props.setCanEdit(true);
      } else {
        props.setCanEdit(false);
      }
    }, [data]);
    const onMount = () => {
      if (!location) {
        setValue("latitude", 0);
        setValue("longitude", 0);
        return;
      }
      if (location.latitude) setValue("latitude", location.latitude);
      if (location.longitude) setValue("longitude", location.longitude);
    };

    useEffect(() => {
      if (open) onMount();
    }, [open]);

    const onSubmit = (data: UpdateIndicatorsData) => {
      const newLocation: Location | undefined = locationIsDifferent
        ? { latitude: data.latitude, longitude: data.longitude }
        : undefined;
      if (newLocation) {
        setNewLocation(newLocation);
        setOpenConfirmLocationEditModal(true);
      }
    };
    React.useImperativeHandle(ref, () => ({
      async submitForm() {
        await handleSubmit(onSubmit)();
      },
    }));
    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{ overflowY: "auto", maxHeight: "80%" }}
        className="d-flex flex-column"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{ fontWeight: "bold", marginTop: "5px", marginBottom: "10px" }}
          >
            Localização
          </Typography>
          <NumberInput
            control={control}
            errors={errors}
            fieldName="latitude"
            label="Latitude"
            style={inputStyle}
          />
          <NumberInput
            control={control}
            errors={errors}
            fieldName="longitude"
            label="Longitude"
            style={inputStyle}
          />
        </div>
      </form>
    );
  }
);
